import React from 'react';
import './card.css';

const Card = ({ title, desc, onUse }) => {
    return (
        <div className="card-container">
            <h3 className="card-title">{title}</h3>
            <div className="card-desc">
                {desc.split('\n').map((line, idx) => (
                    <p key={idx}>{line}</p>
                ))}
            </div>
            <button className="card-button" onClick={onUse}>
                Use this
            </button>
        </div>
    );
};

export default Card;
